/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData model module.
 * @module model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData} The populated <code>EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
            if (data.hasOwnProperty('buyerCount')) {
                obj['buyerCount'] = ApiClient.convertToType(data['buyerCount'], 'Number');
            }
            if (data.hasOwnProperty('rewardPer')) {
                obj['rewardPer'] = ApiClient.convertToType(data['rewardPer'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['email'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['accountNo'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['enabled'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['invCode'] = undefined;

/**
 * @member {Number} userCount
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['userCount'] = undefined;

/**
 * @member {Number} buyerCount
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['buyerCount'] = undefined;

/**
 * @member {Number} rewardPer
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['rewardPer'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventInvitationPartnerListEventInvitationPartnerListData;

